import type { SnapshotRecordArray } from '@ember-data/legacy-compat/legacy-network-handler/snapshot-record-array'
import { assert } from '@ember/debug'
import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'
import { join } from 'teacher-ui-client/utils/uri'

export default class PartnerContactDetailAdapter extends GravityV3Adapter {
  urlForFindAll(modelName: string, snapshots: SnapshotRecordArray) {
    const { host, namespace } = this

    const { partnerId } = snapshots.adapterOptions ?? {}
    assert('find all partner contact details required partnerId', typeof partnerId === 'string')

    const path = this.pathForType(modelName)

    return join(host, namespace, 'partners', partnerId, path).href
  }
}
